// extracted by mini-css-extract-plugin
export default {"default":"DefaultLogin_default__Znlgc","describe":"DefaultLogin_describe__kCUhM","jump_other":"DefaultLogin_jump_other__0U-7l"};